import { get, isEmpty } from 'lodash';

export const ViewActions = {
  getView(property) {
    return property ? get(this.state.view, property) : this.state.view;
  },

  setView(property, value) {
    this.setState((prevState) => ({ ...prevState, view: { ...prevState.view, [property]: value } }));
  },

  setAlerts(alerts) {
    this.setState((prevState) => ({ ...prevState, view: { ...prevState.view, alerts: [...alerts] } }));
  },

  addAlerts(alerts) {
    this.setState((prevState) => {
      const currentAlerts = prevState.view.alerts || [];
      const newAlerts = alerts.filter((newAlert) => !currentAlerts.some((alert) => alert.message === newAlert.message));
      return {
        ...prevState,
        view: { ...prevState.view, alerts: [...currentAlerts, ...newAlerts] },
      };
    });
  },

  removeAlert(index) {
    this.setState((prevState) => {
      const alerts = [...prevState.view.alerts];
      alerts.splice(index, 1);

      return { ...prevState, view: { ...prevState.view, alerts } };
    });
  },

  clearAlerts({ ignoreType } = {}) {
    this.setState((prevState) => ({
      ...prevState,
      view: {
        ...prevState.view,
        alerts: ignoreType ? prevState.view.alerts.filter((alert) => alert.type === ignoreType) : [],
      },
    }));
  },

  getElementY(name) {
    const element = document.getElementsByClassName(name);
    if (element && element[0]) {
      return element[0].getBoundingClientRect().top + window.scrollY - element[0].getBoundingClientRect().height - 60;
    }
    return 0;
  },

  handleBeforeUnload(event) {
    const href = document.activeElement.getAttribute('href');

    if (!href?.startsWith('tel:')) {
      event.preventDefault();
    }
    // TODO: replace the alert with something better
    // alert(`Are you sure you want to leave?`);
    return;
  },

  scrollToLastPosition() {
    let scrollPosition;
    const { getView } = this.state.actions.view;

    if (getView('scrollPosition') !== undefined) {
      scrollPosition = getView('scrollPosition');
    } else {
      scrollPosition = document.querySelector('.Step').firstElementChild.offsetHeight;
    }

    window.scroll(0, scrollPosition);
  },

  scrollToStepFirstElement() {
    window.scroll(0, document.querySelector('.Step').firstElementChild.offsetHeight);
  },

  scrollToWidget(name, behavior = 'smooth') {
    const elementY = this.state.actions.view.getElementY(name);

    if (elementY) {
      window.scrollTo({ top: elementY, behavior });
    }
  },

  // doesn't work properly in strict mode, remove strict mode if you want to test it correctly on localhost
  // TODO: make the logic more generic.
  // Refer to https://bitbucket.org/ezroadmap/ui-framework/pull-requests/1831/overview#comment-593701485
  // for potential idea on how it can be done
  focusWidget(invalidFields) {
    const focusOptions = { preventScroll: true };
    const firstInvalidFieldName = Object.keys(invalidFields)?.[0];
    const elementsByClassName = document.getElementsByClassName(firstInvalidFieldName);

    if (firstInvalidFieldName && elementsByClassName.length > 0) {
      const parentElement = elementsByClassName?.[0];
      const canvasElement = parentElement.getElementsByTagName('canvas')?.[0];
      const inputElement = parentElement.getElementsByTagName('input')?.[0];
      const buttonElement = parentElement.getElementsByTagName('button')?.[0];
      const dropdownElement = inputElement?.previousElementSibling;

      if (canvasElement || inputElement?.type === 'checkbox') {
        // the visual representation of focusing
        document.dispatchEvent(new CustomEvent('focusVisible', { detail: { name: firstInvalidFieldName } }));
        // the real event of focusing
        inputElement?.focus();
        canvasElement?.focus();
      }

      if (inputElement && inputElement?.type !== 'checkbox' && inputElement?.type !== 'file') {
        inputElement.focus(focusOptions);
      } else if (buttonElement) {
        document.dispatchEvent(new CustomEvent('focusVisible', { detail: { name: firstInvalidFieldName } }));
        buttonElement.focus(focusOptions);
      }

      if (dropdownElement) {
        dropdownElement.focus(focusOptions);
      }

      if (parentElement?.tagName === 'BUTTON') {
        parentElement.focus(focusOptions);
      }
    }

    this.state.actions.view.scrollToWidget(firstInvalidFieldName);
  },

  /**
   * set modal view or remove current modal from view
   * @param {{modalName: string, props: object }} modal - modal's name (as defined in App.js) with optional additional props
   */
  toggleModal(modal) {
    if (modal) {
      const modalSettings = this.state.actions.settings.getUserConfigProp('modals')[modal.modalName] || [];
      modal = { modalName: modal.modalName, props: modal.props || {}, modalSettings };
      this.state.actions.view.setView('scrollPosition', window.scrollY);
      this.state.actions.view.clearAlerts();
    } else {
      modal = {};
    }
    this.setState(
      (state) => {
        return { ...state, view: { ...state.view, modal } };
      },
      () => {
        //If hiding the modal - return to last position
        if (isEmpty(modal)) {
          this.state.actions.view.scrollToLastPosition();
        } else {
          window.scroll({ top: 0 });
        }
        this.state.actions.view.clearAlerts();
        document.querySelector('.back-text') && document.querySelector('.back-text').parentElement.focus();
      },
    );
  },

  togglePopupLoader(showPopupLoader, loadingText = null) {
    this.setState((prevState) => {
      const view = {
        ...prevState.view,
        showPopupLoader,
      };

      if (showPopupLoader && loadingText) {
        view['popupLoaderText'] = loadingText;
      } else if (!showPopupLoader) {
        view['popupLoaderText'] = null;
      }

      return {
        ...prevState,
        view,
      };
    });
  },

  redirectToVendorUrl() {
    const { actions } = this.state;
    const vendorUrl = actions.settings.getUserConfigProp('routing.vendorWebsiteUrl');

    window.location.assign(vendorUrl);
  },
};
